import React from 'react'
import styled from 'styled-components'
import Text, { FontStyle } from '~/components/core/Text'

import { LoadingSpinner } from './shared/LoadingSpinner'

const OuterWrapper = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
`

const LoadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export interface LoadingProps {
  text?: string
  fontStyle?: FontStyle
}

export const Loading = ({ fontStyle, text }: LoadingProps) => {
  return (
    <OuterWrapper>
      <LoadingWrapper>
        <LoadingSpinner />
        {text && (
          <Text
            style={{
              fontSize: fontStyle ? undefined : '60px',
              textTransform: 'capitalize',
              lineHeight: '60px',
              textAlign: 'center',
              fontWeight: '700',
              opacity: '.35',
            }}
            fontStyle={fontStyle}
            color="var(--chakra-colors-border-default)"
          >
            Loading {text}
          </Text>
        )}
      </LoadingWrapper>
    </OuterWrapper>
  )
}
